import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import styled from 'styled-components'
import { Select, DatePicker, } from 'antd'
import moment from 'moment';
const { RangePicker } = DatePicker;
const { Option } = Select;

const FlexWrapper = styled.div`
  display:flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  & > * {
    margin-left: 10px;
  }
`


const InputWrapper = styled.div`
  display:flex;
  align-items: center;
  & > div{
    margin-right: 10px;
  }
`
const ChartWrapper = styled.div`
  padding: 16px 20px;
  background-color: #ffffff;
`
Highcharts.setOptions({
  lang: {
    months: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ]
  }
});

class OrderTransChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.state = {
      range: [moment().subtract(30, 'days').startOf('day'), moment().endOf('day')],
      selectedMarket: ['ETH:BTC'],
      type: 0,
    }
  }


  componentDidMount() {
    this.request()
  }

  request = () => {
    this.state.selectedMarket.forEach(element => {
      let market = element.split(':');
      this.props.fetchFunction({ coin: market[0], currency: market[1], type: this.state.type, begin: this.state.range[0].unix(), end: this.state.range[1].unix() });
    });
  }
  handleSelectChange = value => {
    this.setState({ selectedMarket: value }, this.request);
  };
  handleTransTypeChange = (value) => {
    this.setState({ type: value }, this.request)
  }

  handleTransRangeChange = (value) => {
    value[1] = value[1].endOf('day')
    this.setState({ range: value }, this.request)
  }



  render() {

    let series = {}
    this.state.selectedMarket.forEach((item) => {
      series[item] = [{
        name: `Tổng giao dịch ${item}`,
        data: (this.props.orderTrans[item] || []).map((item) => ([item.time_stamp * 1000, item.total_amount]))
      },
      {
        name: `Phí bán ${item}`,
        data: (this.props.orderTrans[item] || []).map((item) => ([item.time_stamp * 1000, item.total_sell_fee]))
      },
      {
        name: `Phí mua ${item}`,
        data: (this.props.orderTrans[item] || []).map((item) => ([item.time_stamp * 1000, item.total_buy_fee]))
      },
      {
        name: `Lượt giao dịch ${item}`,
        data: (this.props.orderTrans[item] || []).map((item) => ([item.time_stamp * 1000, item.total_count]))
      }]
    })
    return (
      <ChartWrapper>
        <FlexWrapper>
          <InputWrapper>
            <Select
              showSearch
              style={{ width: 300 }}
              placeholder="Chọn thị trường"
              optionFilterProp="children"
              mode="multiple"
              onChange={this.handleSelectChange}
              maxTagCount={2}
              defaultValue='ETH:BTC'
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {
                this.props.markets.map((item, index) => (
                  <Option
                    value={`${item.coin}:${item.currency}`}
                    disabled={
                      this.state.selectedMarket.length > 1
                        ? this.state.selectedMarket.includes(`${item.coin}:${item.currency}`)
                          ? false
                          : true
                        : false
                    }
                  >
                    {`${item.coin}:${item.currency}`}
                  </Option>
                ))
              }
            </Select>
          </InputWrapper>
          <InputWrapper>
            <div>Loại:</div>
            <Select
              placeholder="Chọn đồng bạn muốn"
              style={{ width: 120 }}
              onChange={this.handleTransTypeChange}
              defaultValue={0}
            >
              <Option value={0}>Mua</Option>
              <Option value={1}>Bán</Option>
            </Select>
          </InputWrapper>
          <InputWrapper>
            <div>Thời gian:</div>
            <RangePicker
              defaultValue={this.state.range}
              onChange={this.handleTransRangeChange}
              disabledDate={(current) => current && current > moment().endOf('day')}
            />
          </InputWrapper>
        </FlexWrapper>
        {this.state.selectedMarket.map((item) => (
          <HighchartsReact highcharts={Highcharts}
            style={{ flex: 1 }}
            options={{
              chart: {
                type: 'spline'
              },

              title: {
                text: item
              },
              xAxis: {
                type: 'datetime',
                labels: {
                  format: "{value:%e/%B/%Y}",
                },
              },
              yAxis: {
              },
              series: series[item]
            }} />
        ))}
      </ChartWrapper>
    );
  }
}

export default OrderTransChart;